import React from 'react';
import PropTypes from 'prop-types';
import { TooltipHost } from 'office-ui-fabric-react';

const DetailsListOverflowTooltip = ({ ariaLabel, displayContent, tooltipContent }) => (
  <div className="overflow-tooltip">
    <TooltipHost
      content={tooltipContent || displayContent}
      aria-label={ariaLabel || tooltipContent || displayContent}
    >
      {displayContent}
    </TooltipHost>
  </div>
);

DetailsListOverflowTooltip.propTypes = {
  ariaLabel: PropTypes.string,
  displayContent: PropTypes.string.isRequired,
  tooltipContent: PropTypes.string,
};

DetailsListOverflowTooltip.defaultProps = {
  ariaLabel: '',
  tooltipContent: '',
};

export default DetailsListOverflowTooltip;
